<template>
  <div id="wrap_box">
    <CommonHeader></CommonHeader>
    <div class="homepage" :id="appName+'_box'">

      <header id="headTop">
        <div class="homepage_top-logo">
          <!-- <img id="home_logo" :src="logoImg"> -->
        </div>

        <div class="homepage_top-button">
          <template>
            <el-tabs v-model="activeName" @tab-click="handleClick">
              <el-tab-pane label="产品" name="home">
              </el-tab-pane>
              <el-tab-pane label="版本介绍" name="introduce">
              </el-tab-pane>
              <el-tab-pane label="用户指南" name="help">

              </el-tab-pane>
            </el-tabs>
          </template>
          <!-- <el-button type="text" @click="goHelp">用户指南</el-button> -->
          <!-- <el-button type="text" @click="jump()">立即使用</el-button> -->
        </div>

      </header>
      <div class="introduce_box" v-if="activeName ==='introduce'">
        <div class="introduce_top">
          <div class="introduce_top_tit">
            <h2>所见即所得的人机合译平台</h2>
            <h3>A WYSIWYG CAT PLATFORM</h3>
            <h4>选择最适合您的版本</h4>
          </div>
        </div>
        <div class="introduce_main">
          <div class="introduce_main_tit">
            <div></div>
            <h2>版本介绍</h2>
          </div>
          <el-row>
            <!-- type="flex" justify="space-around" -->
            <el-col :sm="24" :md="24" :lg="1" :xl="2">
              <div style="height:100px;"></div>
            </el-col>
            <el-col :sm="10" :md="10" :lg="6" :xl="4" :offset="interval(index)" v-for="(item,index) in editionList"
              :key="index">
              <div :class="'grid_top_'+index" class="grid_top">
                <h5>{{item.name}}</h5>
                <div class="">{{item.synopsis}}</div>
                <button :class="'grid_btn_'+index" @click="goUse(item.url)" class="grid_btn">立即使用</button>
              </div>
              <div class="grid_bottom">
                <div class="divider">
                  <el-divider>功能</el-divider>
                </div>
                <ul class="introduce_one">
                  <li v-for="(val,index) in item.languageFun" :key="index">
                    <span :class="{'no_height':!val.support}">{{val.txt}}</span>
                    <i v-if="val.support" class="el-icon-check"></i>
                  </li>
                </ul>
                <div class="dividing_line_wrap">
                  <div class="dividing_line"></div>
                </div>
                <ul class="introduce_one">
                  <li v-for="(val,index) in item.operationFun" :key="index">
                    <span :class="{'no_height':!val.support}">{{val.txt}}</span>
                    <i v-if="val.support" class="el-icon-check"></i>
                  </li>
                </ul>
                <div class="dividing_line_wrap">
                  <div class="dividing_line"></div>
                </div>
                <ul class="introduce_one">
                  <li v-for="(val,index) in item.characteristicFun" :key="index">
                    <span :class="{'no_height':!val.support}">{{val.txt}}</span>
                    <i v-if="val.support" class="el-icon-check"></i>
                  </li>
                </ul>
              </div>
            </el-col>

          </el-row>
          <div class="explain">
            <span>
              说明：四个版本账号互通，注册一个版本账号后所有版本都可登录使用
            </span>
          </div>
          <Footer></Footer>
        </div>
      </div>
      <div class="main" v-if="activeName ==='home'">
        <div class="homepage_top">
          <el-row :gutter="20">
            <el-col :xs="24" :sm="24">
              <div style="paddingTop:7vw">
                <div class="homepage_top-title">
                  <!-- <h2>{{textObj.t1}}</h2>
                  <h3>{{textObj.t2}}</h3> -->
                </div>
                <!-- <div class="homepage_top-banner">
                <img src="../assets/imgs/product/img.png">
              </div> -->
              </div>
            </el-col>
            <el-col :sm="0" class="hidden-xs-only">
              <!-- <LoginInEmbed style="marginTop: 12vw"></LoginInEmbed> -->
            </el-col>
          </el-row>
          <h5>{{textObj.t1}}</h5>
          <p>{{textObj.t2}}</p>
          <button @click="jump()">立即体验</button>
        </div>
        <div class="homepage_advantages">
          <div class="homepage_advantages-title">
            <h5>产品特点</h5>
            <p>Product Features</p>
          </div>
          <div class="homepage_advantages-list">
            <ul class="homepage_advantages-list_01">
              <li>
                <div><img :src="imgsList.img1"></div>
              </li>
              <li>
                <div class="homepage_advantages-list_01_text advantages-list-box">
                  <h6><span>01</span>{{textObj.t4}}</h6>
                  <p>{{textObj.t5}}</p>
                </div>
              </li>
            </ul>
            <ul class="homepage_advantages-list_02">
              <li>
                <div class="homepage_advantages-list_02_text advantages-list-box">
                  <h6><span>02</span>{{textObj.t6}}</h6>
                  <p>{{textObj.t7}}</p>
                </div>

              </li>
              <li>
                <div><img :src="imgsList.img2"></div>
              </li>
            </ul>
            <ul class="homepage_advantages-list_03">
              <li>
                <div><img :src="imgsList.img4"></div>
              </li>
              <li>
                <div class="homepage_advantages-list_03_text advantages-list-box">
                  <h6><span>03</span>{{textObj.t8}}</h6>
                  <p>{{textObj.t9}}</p>
                </div>
              </li>
            </ul>
            <ul class="homepage_advantages-list_04">

              <li>
                <div class="homepage_advantages-list_04_text advantages-list-box">
                  <h6><span>04</span>{{textObj.t10}}</h6>
                  <p>{{textObj.t11}}</p>
                </div>
              </li>
              <li>
                <div><img :src="imgsList.img3"></div>
              </li>
            </ul>
            <!-- <ul class="homepage_advantages-list_05">
            <li>
              <div><img src="../assets/imgs/product/collaboration.png"></div>
            </li>
            <li>
              <div class="homepage_advantages-list_05_text">
                <h6>05 多人协作</h6>
                <p>·简单直观的多人协作方式，多人协作从未如此简单。</p>
              </div>

            </li>
          </ul> -->
            <div class="bottom_but">
              <p style="font-family: Microsoft YaHei;font-weight: bold;color: #333333;font-size:1vw">{{textObj.t12}}</p>
              <button @click="jump()">立即使用</button>
            </div>
          </div>
        </div>

        <!-- <div class="homepage_contact">
          <div v-if=isblock style="display:flex">
            <div class="homepage_contact_code_outer" style="display:flex;">
              <div class="homepage_contact_code" v-for="(item,index) in contactWXList" :key="index">
                <img :src="item.imgPath">
                <p>{{item.content}}</p>
              </div>
            </div>

            <div class="homepage_contact_address">
              <p class="homepage_contact_address_gohelp">北京中科凡语科技有限公司 ©2019 版</p>
              <p class="homepage_contact_address_01">Beijing Fanyu Technology Co., Ltd ©2019</p>
              <p class="homepage_contact_address_02">京ICP备18045685号-2</p>
              <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010802032721"
                class="homepage_contact_address_03">京公网安备11010802032721号</a>
            </div>
            <div class="homepage_contact_tele">
              <dl>
                <dt>
                  <p>联系方式</p>
                </dt>
                <dd>
                  <p>邮箱：guanghua.li@anylangtech.com</p>
                </dd>
                <dd>
                  <p>电话：010-61934155</p>
                </dd>
                <dd>
                  <p>地址：北京市海淀区知春路甲63号卫星大厦1006室</p>
                </dd>
              </dl>
            </div>
          </div>
          <div class="homepage_contact_address" v-else>
            <ul style="display:flex;aliginItems:center;">
              <li>
                <p class="homepage_contact_address_01">北京中科凡语科技有限公司 ©2019 版</p>
                <p class="homepage_contact_address_02">Beijing Fanyu Technology Co., Ltd ©2019</p>
                <p class="homepage_contact_address_03">京ICP备18045685号-2</p>
              </li>
              <li>
                <p class="homepage_contact_tele">邮箱：guanghua.li@anylangtech.com</p>
                <p class="homepage_contact_tele">电话：010-61934155</p>
              </li>
            </ul>
          </div>
        </div> -->
        <Footer></Footer>
      </div>
      <back-top></back-top>
      <!-- <el-button type="button" style="color:red"></el-button> -->
      <el-dialog v-if="dialogTableVisible" :visible.sync="dialogTableVisible" :closeOnClickModal="false" ref="dialog"
        :lock-scroll="false">
        <span class="cancel" @click="cancel">
          <img src="../assets/imgs/login/lt_close.png" alt="">
        </span>
        <LoginInEmbed></LoginInEmbed>
      </el-dialog>
    </div>
  </div>

</template>

<script>
import BackTop from "./backTop/backTop.vue";
import LoginInEmbed from '../views/login/login_in_embed'
import CommonHeader from '../common/header.vue'
import Footer from '../common/footer.vue'
import '../assets/css/font/font.css';
export default {
  name: "homePage",
  data() {
    return {
      contactWXList: [
        {
          num: 1,
          imgPath: require("../assets/imgs/homepage/lightingyee.png"),
          content: "飞译公众号"
        }, {
          num: 2,
          imgPath: require("../assets/imgs/homepage/fanyuexp.jpg"),
          content: "飞译体验群"
        }, {
          num: 3,
          imgPath: require("../assets/imgs/homepage/fanyu.png"),
          content: "中科凡语公众号"
        }
      ],
      isblock: "",
      isshow: false,
      dialogTableVisible: false,
      activeName: "home",
      editionList: [
        {
          name: "Pro版",
          synopsis: "专业版，适用涉及多语种、多领域翻译企业、翻译团队、个人译者。",
          url: "https://lightingyee.com/#/login/login_in",
          languageFun: [
            { txt: "32个语种", support: true },
            { txt: "中英8个领域", support: true },
            { txt: "11种格式", support: true },
          ],
          operationFun: [
            { txt: "术语库", support: true },
            { txt: "记忆库", support: true },
            { txt: "项目管理", support: true },
            { txt: "任务管理", support: true },
            { txt: "多人协作", support: true },
            { txt: "统计报表", support: true },
          ],
          characteristicFun: [

          ]
        },
        {
          name: "医疗版",
          synopsis: "医疗版，针对医疗领域优化的机器翻译引擎，术语更精准，译文更符合医疗文件风格。",
          url: "https://vip.lightingyee.com/#/login/login_in",
          languageFun: [
            { txt: "中英互译", support: true },
            { txt: "医疗领域", support: true },
            { txt: "11种格式", support: true },
          ],
          operationFun: [
            { txt: "术语库", support: true },
            { txt: "记忆库", support: true },
            { txt: "项目管理", support: true },
            { txt: "任务管理", support: true },
            { txt: "多人协作", support: true },
            { txt: "统计报表", support: true },
          ],
          characteristicFun: [
            { txt: "内置150万医疗词典", support: true }
          ]
        },
        {
          name: "高校版",
          synopsis: "高校版，适用高校BTI、MTI、外语专业等教学场景、翻译实践场景。",
          url: "",
          languageFun: [
            { txt: "32个语种", support: true },
            { txt: "中英8个领域", support: true },
            { txt: "11种格式", support: true },
          ],
          operationFun: [
            { txt: "术语库", support: true },
            { txt: "记忆库", support: true },
            { txt: "项目管理", support: true },
            { txt: "任务管理", support: true },
            { txt: "多人协作", support: true },
            { txt: "统计报表", support: true },
          ],
          characteristicFun: [
            { txt: "作业模式", support: true },
            { txt: "作业评分", support: true }
          ]
        },
        {
          name: "Lite版",
          synopsis: "轻量版，适用各行业非翻译从业人士，快速上手，极简机器翻译和译后编辑流程。",
          url: "https://lite.lightingyee.com/#/login",
          languageFun: [
            { txt: "中英俄法语种", support: true },
            { txt: "通用领域", support: true },
            { txt: "10种格式", support: true },
          ],
          operationFun: [
            { txt: "术语库", support: true },
            { txt: "记忆库", support: false },
            { txt: "项目管理", support: true },
            { txt: "任务管理", support: false },
            { txt: "多人协作", support: false },
            { txt: "统计报表", support: false },
          ],
          characteristicFun: [

          ]
        }
      ],
      testArr: [
        "http://dev.anylangtech.com/cat-web/#/login/login_in",
        "http://dev.anylangtech.com/medical-web/#/login/login_in",
        "http://dev.anylangtech.com/cat-tech/",
        "http://dev.anylangtech.com/cat-lite/"
      ],
      productionArr: [

      ],
      textObj: {
        t1: "飞译CAT-通用版",
        t2: "通用人机合译平台，适用涉及多语种、多领域翻译团队个人译者",
        t3: "选择最适合您的版本",
        t4: " 多语种、多领域",
        t5: "·32个语种，中英7个细分领域，覆盖大多数笔译业务场景",
        t6: " 所见即所得",
        t7: "·首款所见即所得的在线编辑界面，翻译全程保留格式，全新翻译体验 ",
        t8: " 人机合译",
        t9: "·翻译过程单词补全，实时人机互动，人机合译，共同进步",
        t10: " 多人协作",
        t11: "·简单直观的多人协作方式，项目进度、项目统计尽在掌握 ",
        t12: "全语种、多领域的新一代CAT，让译者专注翻译",
      },
      logoImg: require("../assets/imgs/homepage/logo.png"),
      imgsList: {
        img1: require("../assets/imgs/product/complex.png"),
        img2: require("../assets/imgs/product/see_get.png"),
        img3: require("../assets/imgs/product/machine _translation.png"),
        img4: require("../assets/imgs/product/locked _repetition.png"),
      }
    }
  },
  components: { BackTop, LoginInEmbed, CommonHeader, Footer },

  created() {
    if (window.innerWidth < 768) {
      this.$router.push({ path: "/propaganda", query: {} })
    }
    this.appName = process.env.VUE_APP_NAME;
    window.location.href = PTURL + "cat/publicity?name=" + this.appName
    switch (this.appName) {
      case 'hospital': // 医疗
        this.textObj = {
          t1: "飞译CAT-医疗版",
          t2: "医疗人机合译平台，面向医疗翻译场景打造、医疗翻译更专业",
          t3: "选择最适合您的版本",
          t4: " 医疗机翻引擎",
          t5: "·针对医疗领域优化、译文更符合医疗文件风格",
          t6: " 精准医疗术语",
          t7: "·支持实时添加术语、内置150万条医疗词典",
          t8: " 所见即所得",
          t9: "·首款所见即所得的在线编辑界面，翻译全程保留格式，全新翻译体验",
          t10: " 多人协作",
          t11: "·简单直观的多人协作方式，项目进度、项目统计尽在掌握 ",
          t12: "专门为医疗翻译场景而打造的新一代CAT"
        }
        this.logoImg = require("../assets/imgs/homepage/yl_logo.png");
        this.imgsList = {
          img1: require("../assets/imgs/product/yl_01.png"),
          img2: require("../assets/imgs/product/yl_02.png"),
          img3: require("../assets/imgs/product/yl_03.png"),
          img4: require("../assets/imgs/product/yl_04.png"),
        }
        break;
      case 'school': // 高校
        this.textObj = {
          t1: "飞译CAT-高校版",
          t2: "高校人机合译平台，适用高校BTI、MTI、外语专业等翻译教学翻译实践场景",
          t3: "选择最适合您的版本",
          t4: " 多语种、多领域",
          t5: "·32个语种，中英7个细分领域，覆盖多语种教学、实践场景",
          t6: " 作业模式",
          t7: "·一键分配作业，作业评分",
          t8: " 所见即所得",
          t9: "·首款所见即所得的在线编辑界面，翻译全程保留格式，全新翻译体验",
          t10: " 多人协作",
          t11: "·简单直观的多人协作方式，项目进度、项目统计尽在掌握 ",
          t12: "面向高校翻译教学、翻译生产实践的新一代CAT"
        }
        this.logoImg = require("../assets/imgs/homepage/yl_logo.png");
        this.imgsList = {
          img1: require("../assets/imgs/product/gx_01.png"),
          img2: require("../assets/imgs/product/gx_02.png"),
          img3: require("../assets/imgs/product/gx_03.png"),
          img4: require("../assets/imgs/product/gx_04.png"),
        }
        break;
      default:
        break;
    }
    window.addEventListener('scroll', this.scorll)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('scroll', this.scorll)
    })
  },

  methods: {
    // 栅格系统间距
    interval(index) {
      // return 1
      return index === 0 ? 0 : 1
    },
    // 去使用版本
    goUse(url) {
      window.open(url);
    },
    // 选项卡事件
    handleClick(tab, event) {
      this.activeName = tab.name
      if (tab.name == "help") {
        this.goHelp()
      }
    },
    //获取地址栏的参数
    getUrlParam(name) {
      let that = this
      var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
      var r = window.location.search.substr(1).match(reg);
      if (r != null) return unescape(r[2]);
      return null;
    },
    // 关闭遮罩层
    cancel() {
      clearTimeout(sT)
      this.$refs.dialog.$el.style.transform = "translate(29%,-46%) scale(0)"
      this.$refs.dialog.$el.style.transitionDuration = "1s"
      let sT = setTimeout(() => {
        this.$refs.dialog.$el.style.display = "none"
        this.dialogTableVisible = false
      }, 1000);
    },
    jump() {


      //↓↓↓↓↓↓↓↓原有登录方式
      if (window.innerWidth < 768) {
        this.isshow = true;
        // this.isshow();
        // {
        // this.$alert('这是一段内容', '标题名称', {
        //   confirmButtonText: '确定', 
        //   center: true
        // });

        // this.$alert('请在PC端登录');
        // }
      } else {
        this.$router.push('/home');
      }

    },
    goHelp() {
      this.$router.push({ name: 'help' })
    },
    // showTop(){
    //   if (document.documentElement.scrollTop > 0) {
    //       console.log(1111);
    //   }
    // },
    scorll() {
      let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      if (scrollTop > 46) {
        document.querySelector('#headTop').style.backgroundColor = "#2a7aeb";
        document.querySelector('#headTop').style.top = "0";
        // document.querySelector('#home_logo').src = require("../assets/imgs/login/kj_logo.png");//../assets/imgs/homepage/logo.png
      }
      if (scrollTop < 46) {
        document.querySelector('#headTop').style.backgroundColor = "";
        document.querySelector('#headTop').style.top = "auto";
        // document.querySelector('#home_logo').src = this.logoImg;//
      }
    },
    isBlock() {
      if (window.innerWidth > 768) {
        this.isblock = true;
        // this.dialogTableVisible = true
      } else {
        this.isblock = false;
        this.dialogTableVisible = false
      }
    },
    isShow() {
      if (this.isshow) {
        this.isshow = false;
      } else {
        this.isshow = true;
      }
    }

  },
  mounted() {
    this.isBlock();
    window.addEventListener('resize', this.isBlock);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.isBlock);
  },
  beforeRouteEnter(to, from, next) {
    document.body.style.zoom = 1;
    next();
  },
  // beforeRouteLeave(to,from,next){
  //   if(window.innerWidth > 992 && window.innerWidth < 1366){ n  tjh f
  //     document.body.style.zoom = 0.8;
  //   }
  //   next();
  // }

}
</script>
<style lang="less" scoped>
.introduce_box {
  .introduce_top {
    background: url("../assets/imgs/homepage/top_version_introduction_bg.png")
      no-repeat center;
    background-size: cover;
    height: 61vh;
    position: relative;
    .introduce_top_tit {
      position: absolute;
      left: 25vw;
      top: 20vh;
      color: #fff;
      h2 {
        font-size: 36px;
      }
      h3 {
        font-size: 24px;
      }
      h4 {
        margin-top: 20px;
        font-size: 28px;
      }
    }
  }

  .introduce_main {
    /deep/.el-row {
      margin-top: 73px;
      .el-col-offset-2 {
        margin-left: 10.6%;
      }
      .el-col-xl-2 {
        width: 10.6666%;
      }
      .el-col {
        .grid_top {
          // width: 324px;
          height: 343px;
          position: relative;

          h5 {
            height: 80px;
            font-size: 28px;
            line-height: 80px;
            text-align: center;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(255, 255, 255, 1);
          }
          border-radius: 4px;
          &_0 {
            background: linear-gradient(
              -47deg,
              rgba(37, 55, 231, 1) 0%,
              rgba(45, 201, 239, 1) 100%
            );
          }
          &_1 {
            background: linear-gradient(
              -47deg,
              rgba(9, 129, 159, 1) 0%,
              rgba(129, 222, 245, 1) 100%
            );
          }
          &_2 {
            background: linear-gradient(
              -47deg,
              rgba(29, 66, 228, 1) 0%,
              rgba(172, 193, 255, 1) 100%
            );
          }
          &_3 {
            background: linear-gradient(
              -47deg,
              rgba(30, 50, 106, 1) 0%,
              rgba(62, 99, 203, 1) 100%
            );
          }
          div {
            width: 241px;
            height: 67px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
            line-height: 26px;
            margin: 0 auto;
          }
          .grid_btn {
            width: 200px;
            height: 38px;
            color: #ffffff;

            position: absolute;
            left: 50%;
            margin-top: 105px;
            transform: translateX(-50%);
            &_0 {
              background: rgba(73, 145, 244, 1);
              box-shadow: 0px 0px 6px 0px rgba(73, 145, 243, 0.5);
            }
            &_1 {
              background: rgba(99, 199, 223, 1);
              box-shadow: 0px 0px 6px 0px rgba(86, 200, 228, 0.5);
            }
            &_2 {
              background: rgba(155, 177, 251, 1);
              box-shadow: 0px 0px 6px 0px rgba(73, 145, 243, 0.5);
            }
            &_3 {
              background: rgba(51, 90, 195, 1);
              box-shadow: 0px 0px 6px 0px rgba(73, 145, 243, 0.5);
            }
          }
        }
        .grid_bottom {
          // width: 324px;
          height: 649px;
          margin-top: 27px;
          margin-bottom: 50px;
          background: rgba(255, 255, 255, 1);
          border-radius: 4px;
          border: 1px solid rgba(207, 229, 245, 1);
          &:hover {
            box-shadow: 0px 0px 10px 0px rgba(49, 80, 215, 0.2);
          }
          .divider {
            position: relative;
            text-align: center;
            height: 40px;
            margin-top: 20px;
            .el-divider--horizontal {
              width: 70%;
              position: absolute;
              left: 50%;
              transform: translateX(-50%);
              .el-divider__text {
                font-weight: bold;
                color: rgba(51, 51, 51, 1);
                font-size: 18px;
              }
            }
          }
          .introduce_one {
            box-sizing: border-box;
            padding: 0 15%;
            li {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: rgba(67, 67, 67, 1);
              // line-height: 30px;
              margin-top: 20px;
            }
            .no_height {
              color: rgba(173, 170, 170, 1);
            }
            .el-icon-check {
              float: right;
              color: #3783f9;
              margin-top: 5px;
            }
          }
          .dividing_line_wrap {
            width: 100%;
            box-sizing: border-box;
            padding: 0 15%;
            .dividing_line {
              width: 100%;
              height: 1px;
              background: #d1d3d8;
              margin-top: 30px;
            }
          }
        }
      }
    }
    .explain {
      width: 100%;
      box-sizing: border-box;
      padding: 0 11%;
      font-size: 16px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #666666;
      margin-bottom: 56px;
      span {
        margin-left: 7%;
      }
    }
    .introduce_main_tit {
      margin-top: 40px;
      div {
        width: 50px;
        height: 4px;
        background: linear-gradient(
          90deg,
          rgba(251, 81, 94, 1) 0%,
          rgba(251, 105, 79, 1) 100%
        );
        border-radius: 2px;
        margin: 0 auto;
        margin-bottom: 10px;
      }
      h2 {
        font-size: 34px;
        font-weight: bold;
        color: rgba(22, 30, 109, 1);
        text-align: center;
      }
    }
    // .introduce_main_list {
    //   width: 100%;
    //   height: 100%;
    //   margin: 0 auto;
    // }
    // .introduce_main_list > li {
    //   width: 17vw;
    //   float: left;
    // }
  }
}
/* 通用样式 start */
#standard_box {
  .advantages-list-box h6 {
    background: transparent;
    color: #65adff;
  }
  .homepage_top {
    background: url("../assets/imgs/homepage/tongyongbna-toutu.png") no-repeat
      center;
    background-size: 100% 100%;
    height: 37.2vw;
  }
  .bottom_but {
    font-size: 12px;
    button {
      background: #045dff;
    }
  }
}
/* 通用样式 end */
/* 医疗样式 start */
#hospital_box {
  .main {
    background: url("../assets/imgs/homepage/pc_yl_bg.png") no-repeat center;
    background-size: 100% 100%;
  }
  .advantages-list-box h6 {
    background: transparent;
    color: #3674ba;
    span {
      width: 40px;
      height: 40px;
      background: #3674ba;
      border-radius: 4px;
      color: #ffffff;
    }
  }
  .bottom_but {
    font-size: 12px;
    button {
      // background: #3674ba;
    }
  }
  .homepage_contact {
    background: linear-gradient(-55deg, #174e98, #4a8dd1);
  }
  .homepage_top {
    background: url("../assets/imgs/homepage/yiliaoban-toutu.png") no-repeat
      center;
    background-size: 100% 100%;
    height: 37vw;
  }
}
/* 医疗样式 end */

/* 高校样式 start */
#school_box {
  .main {
    background: url("../assets/imgs/homepage/pc_gx_bg.png") no-repeat center;
    background-size: 100% 100%;
  }
  .advantages-list-box h6 {
    background: #3e82f2;
  }
  .bottom_but {
    button {
      background: #045dff;
    }
  }
  .homepage_contact {
    background: #4d64ca;
  }
  .homepage_top {
    background: url("../assets/imgs/homepage/gaoxiaobanben-toutu.png") no-repeat
      center;
    background-size: 100% 100%;
    height: 36vw;
  }
}
/* 高校样式 end */
.homepage {
  .main {
    background: url("../assets/imgs/homepage/pc_ty_bg.png") no-repeat center;
    background-size: 100% 100%;
  }
  .bottom_but {
    text-align: center;
    button {
      margin-top: 30px;
      width: 100px;
      height: 40px;
      background: #4c82f7;
      box-shadow: 0px 0px 10px 0px rgba(76, 130, 247, 0.6);
      border-radius: 4px;
      color: #ffffff;
    }
  }
  header {
    width: 100vw;
    position: fixed;
    // background-color: #ebebeb;
    margin: 0 auto;
    z-index: 100;
    // width:73.3vw;
    display: flex;
    justify-content: space-between;
    .homepage_top-logo {
      float: left;
      padding-left: 15vw;
      padding-top: 0.6vw;
      // box-shadow:0px 0px 50px 0px rgba(54,54,54,0.4);
      img {
        width: 3.2vw;
      }
    }
    .homepage_top-button {
      min-width: 22vw;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding-right: 214px;
      /deep/.el-tabs {
        overflow-y: hidden;
        // .is-active {
        //   color: #4b62f1;
        // }
        // .el-tabs__active-bar {
        //   background: #4b62f1;
        // }
        .el-tabs__header {
          .el-tabs__nav-wrap {
            margin-top: 20px;
          }
        }
      }

      .el-button {
        margin-left: 60px;
        padding: 0.3vw 1.1vw;
        align-items: center;
        // font-size:20px;
        color: #ffffff;
        font-family: Microsoft YaHei;
        border: 2px solid #ffffff;
        border-radius: 26px;
        background: #4b62f1;
        box-shadow: 0px 0px 20px 0px rgba(75, 99, 241, 0.5);

        // margin-left: 10%;
      }
    }
  }
  &_top {
    // background: url("../assets/imgs/homepage/fist_background.jpg");
    background-repeat: no-repeat;
    background-size: 100vw auto;
    height: 20.2vw;
    padding: 0 10vw;
    box-sizing: border-box;
    h5 {
      font-size: 3vw;
      color: #ffffff;
    }
    p {
      font-size: 1.2vw;
      color: #ffffff;
      margin-top: 1vw;
    }
    button {
      margin-top: 2vw;
      width: 11.5vw;
      height: 3.5vw;
      font-size: 1.3vw;
      color: #ffffff;
      border: 1px solid #ffffff;
      background: transparent;
    }
    &-title {
      margin-left: 15.5vw;
      // margin-top: 2.2vw;
      // position:relative;
      // top:2.2vw;
      h2 {
        // font-size:36px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #151e6d;
      }
      h3 {
        padding-top: 0.72vw;
        // font-size:24px;
        // font-size:calc(100vw / 24 );
        font-family: Microsoft YaHei;
        font-weight: bold;
        color: #151e6d;
      }
    }
    &-banner {
      //background: #999;
      height: 26.7vw;
      width: 49vw;
      margin: 0 auto;
      margin-top: 4.3vw;
      // box-shadow: 0px 0px 50px 0px rgba(54, 54, 54, 0.4);
      border-radius: 6px;
      img {
        width: 100%;
      }
    }
  }
  &_advantages {
    // background: url("../assets/imgs/homepage/intermediate_graph.jpg");

    background-repeat: no-repeat;
    background-size: 100vw auto;
    height: 200.9vw;
    padding: 4.3vw 9.8vw;
    box-sizing: border-box;
    &-title {
      h5 {
        // width: 11.6vw;
        margin: 0 auto;
        // font-size:34px;
        font-family: Microsoft YaHei;
        font-weight: bold;
        text-align: center;
        color: #151e6d;
        // border:4px solid rgba(51,51,51,1);
        // padding:1vw 2.5vw;
      }
      p {
        font-family: Microsoft YaHei;
        padding-top: 0.9vw;
        text-align: center;
        // font-size:22px;
        color: #151e6d;
        font-weight: bold;
      }
    }
    &-list_01,
    &-list_03,
    &-list_05 {
      padding-top: 3vw;
      display: flex;
      img {
        // width:41.7vw;
        // height:30.4vw;
        padding-top: 3.2vw;
      }
      &_text {
        margin-left: 7.6vw;
        margin-top: 13.9vw;
        h6 {
          // width:220px;
          height: 2.6vw;
          background: linear-gradient(
            90deg,
            rgba(73, 127, 245, 1) 0%,
            rgba(101, 173, 255, 1) 100%
          );
          // font-size: 26px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          // line-height:2.6vw;
          margin-left: 0.8vw;
        }
        p {
          // font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          padding-top: 2.6vw;
        }
      }
    }
    &-list_03,
    &-list_05 {
      padding-top: 5.9vw;
    }
    &-list_02,
    &-list_04 {
      display: flex;
      padding-top: 5.9vw;
      img {
        // width:41.7vw;
        // height:30.4vw;
        padding-top: 3.2vw;
      }
      &_text {
        // margin-left:7.6vw;
        margin-top: 10.9vw;
        h6 {
          width: 11.5vw;
          height: 2.6vw;
          background: linear-gradient(
            90deg,
            rgba(73, 127, 245, 1) 0%,
            rgba(101, 173, 255, 1) 100%
          );
          // font-size: 26px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(255, 255, 255, 1);
          text-align: center;
          // line-height:2.6vw;
          margin-left: 0.8vw;
        }
        p {
          // font-size: 20px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          padding-top: 2.6vw;
        }
      }
    }
    &-list_01 {
      img {
        width: 41.7vw;
        height: 30.4vw;
      }
    }
    &-list_02 {
      img {
        width: 43.2vw;
        height: 38.3vw;
      }
    }
    &-list_03 {
      padding-top: 11vw;
      img {
        width: 47.7vw;
        height: 32vw;
      }
    }
    &-list_04 {
      img {
        width: 51vw;
        height: 42.4vw;
      }
    }
    &-list_05 {
      img {
        width: 42.3vw;
        height: 33.7vw;
      }
    }
  }
  &_contact {
    // background: url("../assets/imgs/homepage/third_background.jpg");
    // background-repeat: no-repeat;
    // background-size: 100vw auto;
    display: flex;
    justify-content: center;
    height: 15.6vw;
    // padding: 5.3vw 20vw;
    background: linear-gradient(
      -47deg,
      rgba(37, 55, 231, 1) 0%,
      rgba(45, 201, 239, 1) 100%
    );
    box-sizing: border-box;
    font-family: "Microsoft YaHei";
    font-weight: bold;
    // font-size:16px;
    color: #fff;
    padding: 3.9vw 5.8vw;
    &_code {
      padding-right: 2.6vw;
      text-align: center;
      img {
        width: 6.1vw;
        height: 6.1vw;
      }
      p {
        margin-top: 1.1vw;
        margin: 1.1vw auto 2.1vw;
        text-align: center;
        // font-size:8px;
      }
    }
    &_address {
      padding-left: 2.6vw;
      &_gohelp {
        // width: 4.8vw;
        // color: #3399ea;
        padding-bottom: 0.7vw;
      }
      &_gohelp:hover {
        // color: #3399ea;
        // text-decoration: underline;
      }

      &_01 {
        padding-top: 1vw;
      }
      &_02 {
        padding-top: 1vw;
      }
      &_03 {
        display: block;
        color: #ffffff;
        padding-top: 1vw;
      }
    }
    &_tele {
      padding-left: 4.6vw;
      // font-size:16px;
      dt {
        padding-bottom: 0.7vw;
      }
      dd {
        padding-top: 1vw;
      }
    }
  }
}
</style>
<style lang="less" scoped>
// 轮播图的样式
// .homepage_top-banner{
//   .el-carousel__container{
//       .el-carousel__arrow {
//           display:none;
//       }
//   }

//   .el-carousel__indicators--outside{
//     button{
//         width:0.83vw;
//         height:0.83vw;
//         margin-left:1.56vw;
//         background:rgba(200,200,200,1);
//         border-radius:8px;
//         // position:absolute;
//         // top:1.5vw;
//     }
//   }
//   .is-active{
//     button{
//         width:3.64vw;
//         height:0.83vw;
//     }
//   }
// }
/deep/.el-tabs {
  height: 100%;
  overflow-y: auto;
  .is-active {
    color: #ffffff;
  }
  .el-tabs__item {
    font-size: 16px;
    font-weight: bold;
    padding: 0 30px;
    color: #f5f5f5;
    &:hover {
      color: #ffffff;
    }
  }
  .el-tabs__active-bar {
    background-color: #ffffff;
  }
}
/deep/.el-tabs__nav-wrap::after {
  background: transparent;
}
@media screen and (max-width: 768px) {
  .homepage {
    #headTop {
      .homepage_top-button {
        .el-button {
          font-size: 8px;
        }
      }
    }
    &_top {
      &-title {
        h2 {
          font-size: 14px;
        }
        h3 {
          font-size: 10px;
        }
      }
    }
    &_advantages {
      &-title {
        h5 {
          font-size: 14px;
        }
        p {
          font-size: 8px;
        }
      }
      &-list_01,
      &-list_03,
      &-list_05 {
        &_text {
          h6 {
            width: 88px;
            height: 20px;
            font-size: 10px;
            line-height: 20px;
          }
          p {
            font-size: 8px;
          }
        }
      }
      &-list_02,
      &-list_04 {
        &_text {
          h6 {
            width: 88px;
            height: 20px;
            font-size: 10px;
            line-height: 20px;
          }
          p {
            font-size: 8px;
          }
        }
      }
    }
    &_contact {
      display: flex;
      justify-content: center;
      &_address {
        padding-left: 0px;
        &_01 {
          padding-top: 1vw;
        }
      }
      &_tele {
        padding-top: 1vw;
      }
    }
  }
}
//最小768
@media screen and (min-width: 768px) and (max-width: 992px) {
  .homepage {
    #headTop {
      .homepage_top-button {
        .el-button {
          font-size: 8px;
        }
      }
    }
    &_top {
      &-title {
        h2 {
          font-size: 14px;
        }
        h3 {
          font-size: 10px;
        }
      }
    }
    &_advantages {
      &-title {
        h5 {
          font-size: 14px;
        }
        p {
          font-size: 8px;
        }
      }
      &-list_01,
      &-list_03,
      &-list_05 {
        &_text {
          h6 {
            width: 88px;
            height: 20px;
            font-size: 10px;
            line-height: 20px;
          }
          p {
            font-size: 8px;
          }
        }
      }
      &-list_02,
      &-list_04 {
        &_text {
          h6 {
            width: 88px;
            height: 20px;
            font-size: 10px;
            line-height: 20px;
          }
          p {
            font-size: 8px;
          }
        }
      }
    }
    &_contact {
      font-size: 6px;
      display: flex;
      justify-content: center;
      &_tele {
        font-size: 6px;
      }
    }
  }
}
//最小992
@media screen and (min-width: 992px) and (max-width: 1200px) {
  .homepage {
    header {
      .homepage_top-button {
        .el-button {
          font-size: 10px;
        }
      }
    }
    &_top {
      &-title {
        h2 {
          font-size: 18px;
        }
        h3 {
          font-size: 12px;
        }
      }
    }
    &_advantages {
      &-title {
        h5 {
          font-size: 18px;
        }
        p {
          font-size: 12px;
        }
      }
      &-list_01,
      &-list_03,
      &-list_05 {
        &_text {
          h6 {
            width: 114px;
            height: 26px;
            font-size: 13px;
            line-height: 26px;
          }
          p {
            font-size: 10px;
          }
        }
      }
      &-list_02,
      &-list_04 {
        &_text {
          h6 {
            width: 114px;
            height: 26px;
            font-size: 14px;
            line-height: 26px;
          }
          p {
            font-size: 10px;
          }
        }
      }
    }
    &_contact {
      font-size: 8px;
      &_tele {
        font-size: 8px;
      }
    }
  }
  .introduce_main {
    /deep/.el-row {
      margin-top: 73px;
      .el-col-offset-2 {
        margin-left: 4.6667%;
      }
    }
  }
}
//最小992  最大1366
@media screen and (min-width: 992px) and (max-width: 1366px) {
  /deep/ .homepage {
    zoom: 1 !important;
    height: 100%;
  }
}

//最小1200
@media screen and (min-width: 1200px) and (max-width: 1920px) {
  .homepage {
    header {
      .homepage_top-button {
        .el-button {
          font-size: 14px;
        }
      }
    }
    &_top {
      &-title {
        h2 {
          font-size: 22px;
        }
        h3 {
          font-size: 16px;
        }
      }
    }
    &_advantages {
      &-title {
        h5 {
          font-size: 22px;
        }
        p {
          font-size: 14px;
        }
      }
      &-list_01,
      &-list_03,
      &-list_05 {
        &_text {
          h6 {
            width: 138px;
            height: 32px;
            font-size: 16px;
            line-height: 32px;
          }
          p {
            font-size: 12px;
          }
        }
      }
      &-list_02,
      &-list_04 {
        &_text {
          h6 {
            width: 138px;
            height: 32px;
            font-size: 16px;
            line-height: 32px;
          }
          p {
            font-size: 12px;
          }
        }
      }
    }
    &_contact {
      font-size: 10px;
      &_tele {
        font-size: 10px;
      }
    }
  }
}
//最小1920
@media screen and (min-width: 1920px) {
  .homepage {
    header {
      .homepage_top-button {
        .el-button {
          font-size: 20px;
        }
      }
    }
    &_top {
      &-title {
        h2 {
          font-size: 36px;
        }
        h3 {
          font-size: 24px;
        }
      }
    }
    &_advantages {
      &-title {
        position: relative;
        h5 {
          font-size: 34px;
        }
        p {
          font-size: 22px;
        }
        &::before {
          content: "";
          width: 50px;
          height: 4px;
          background: linear-gradient(90deg, #fb525e 0%, #fb6a50 100%);
          border-radius: 2px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          top: -18px;
        }
      }
      &-list_01,
      &-list_03,
      &-list_05 {
        &_text {
          h6 {
            width: 230px;
            height: 50px;
            font-size: 26px;
            line-height: 50px;
          }
          p {
            font-size: 20px;
          }
        }
      }
      &-list_02,
      &-list_04 {
        &_text {
          h6 {
            width: 220px;
            height: 50px;
            font-size: 26px;
            line-height: 50px;
          }
          p {
            font-size: 20px;
          }
        }
      }
    }
    &_contact {
      font-size: 16px;
      &_tele {
        font-size: 16px;
      }
    }
    .bottom_but {
      font-size: 20px;
    }
  }
}
/deep/.el-dialog {
  margin-top: 30vh !important;
  width: 18%;
  // height: 30%;
  border-radius: 10px;
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    // width: 100%;
    // height: 100%;
    padding: 0;
    .cancel {
      position: absolute;
      right: -28px;
      top: -21px;
      cursor: pointer;
    }
  }
  .loding {
    top: -231px !important;
    left: 328px !important;
    transform: scale(0) !important;
    transition-duration: 3s !important;
  }
}
</style>
<style lang="less">
#el-message {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 1);
  opacity: 0.7;
  z-index: 999;
}
.el-message-box {
  width: 60%;
  font-size: 14px;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1100;
  padding: 10px;
  // display:flex;
  // flex-direction: column;
  &-x {
    // width:50px;
    height: 20px;
    // padding-right:10px;
    box-sizing: border-box;
    // text-align: right;
    float: right;
    text-align: center;
    margin-right: 10px;
  }
  &-text {
    width: 60%;
    text-align: center;
    height: 120px;
    line-height: 100px;
    margin: 0 auto;
  }
  &-button {
    width: 50px;
    height: 30px;
    color: #fff;
    font-size: 12px !important;
    background: #454545;
    border-radius: 2px;
    // text-align: right;
    //  box-sizing: border-box;
    float: right;
    margin-right: 10px;
    margin-top: -30px;
  }
}
</style>